<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import datatableMixin from '@/helpers/mixins/datatableMixin'
import Datatable from '@/components/Datatable'

export default {
  page: {
    title: "Stok Yönetimi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
    mixins: [ datatableMixin ],
    components: {
        Layout,
        PageHeader,
        Datatable
    },
  data() {
    return {
            list: {},
            title: "STOK YÖNETİMİ",
            items: [
            {
                text: "ANASAYFA",
                href: "/",
            },
            {
                text: "STOK YÖNETİMİ",
                active: true,
            },
            ],
                        isLoading: false,
                        rows: [],
                        histories: [],

                        // movements table (datatable mixin will manage data)
                        depots: [],
                        selectedRow: null,
                        detailModalVisible: false,

                        /*
                          Stok hareket tipleri:
                          created                       - Depoya yeni ürün/stok kaydı açıldı
                          added                         - Mevcut stok kartına miktar eklendi
                          transfer_to_depot             - Bir depodan başka depoya transfer edildi
                          attached_to_subscription      - Ürün müşteriye teslim / atandı
                          attached_to_transmitter       - Ürün vericiye gönderildi
                          attached_to_transmitter_group - Ürün POP noktasına gönderildi
                          return_to_depot               - Ürün depoya iade edildi
                          defective_return              - Arızalı ürün depoya iade edildi
                          marked_defective              - Ürün arızalı olarak işaretlendi
                          sale                          - Ürün satışı
                          return                        - Genel iade
                          unknown                       - Tipi belirlenemeyen hareket
                          adjustment                    - Eski kayıt; kaynak/hedefe göre yukarıdaki tiplere çevrilir
                        */
                        movementTypes: [
                            { value: 'created', label: 'Yeni stok kaydı' },
                            { value: 'added', label: 'Stok miktarı eklendi' },
                            { value: 'transfer_to_depot', label: 'Depolar arası transfer' },
                            { value: 'attached_to_subscription', label: 'Müşteriye teslim' },
                            { value: 'attached_to_transmitter', label: 'Vericiye gönderim' },
                            { value: 'attached_to_transmitter_group', label: 'POP noktasına gönderim' },
                            { value: 'return_to_depot', label: 'Depoya iade' },
                            { value: 'defective_return', label: 'Arızalı ürün iadesi' },
                            { value: 'marked_defective', label: 'Arızalı işaretlendi' },
                            { value: 'sale', label: 'Satış' },
                            { value: 'return', label: 'İade' },
                            { value: 'unknown', label: 'Bilinmeyen hareket' },
                        ],
                        filter: {
                            device_query: '',
                            user_id: null,
                            movement_type: null,
                            date_from: null,
                            date_to: null
                        },
                        columns: [
                            { name: 'Hareket Tipi', key: 'movement_type', orderable: false },
                            { name: 'Nerden', key: 'source_name', orderable: false },
                            { name: 'Nereye', key: 'destination_name', orderable: false },
                            { name: 'Grup', key: 'stock_group_name', orderable: false },
                            { name: 'Ürün', key: 'stock_name', orderable: true },
                            { name: 'Açıklama', key: 'description', orderable: false },
                            { name: 'Miktar', key: 'amount', orderable: false },
                            { name: 'Tarih', key: 'created_at', orderable: false }
                        ],
                        tableData: {
                            data: [],
                            pagination: { current_page:1, last_page:1, total:0 },
                            detail: true,
                            detailOpen: false,
                            excel: false,
                            searchable: {
                                visible: true,
                                placeholder: 'Barkod, ürün, grup veya açıklama ara'
                            }
                        },
                        endpoint: '/stock/history/movements',
                        params: { per_page: 50, page: 1 },
                        searchParams: {},
                        exportName: 'STOK_HAREKETLERI',
                        disableAutoLoad: true,
                        deviceSearchTimer: null,
                        loadRequestId: 0,
        };
    },
    methods: {
        group_id(rowObj) {
            const data = {
                "an" : "Anten",
                "ka" : "Kablo",
                "mo" : "Modem",
                "sm" : "Sarf Malzeme",
                "si" : "Sabit İp Ücreti",
            }
            return  data[rowObj.group_id]
        },
        formatAmount(value) {
            if (value === null || value === undefined || value === '') return '';
            const n = parseFloat(value);
            if (Number.isNaN(n)) return value;
            return Number.isInteger(n) ? n.toString() : n.toString();
        },
        formatAmountWithUnit(value, unit) {
            const amt = this.formatAmount(value);
            if (!unit) return amt;
            return `${amt} ${unit}`;
        },
        deviceText({status, username, transmitter_name, user_name}) {
            switch (status) {
                case 1:
                return user_name;
                case 2:
                return `Müşteride ${username}`;
                case 3:
                return `Vericide ${transmitter_name}`;
                default:
                return "Bilinmeyen Durum";
            }
        },
        resolveMovementType(row) {
            const type = row && row.movement_type ? row.movement_type : '';
            if (this.movementTypes.some(item => item.value === type)) {
                return type;
            }

            const source = row.source_type;
            const dest = row.destination_type;
            const desc = (row.description || '').toLowerCase();

            if (dest === 'subscription') return 'attached_to_subscription';
            if (dest === 'transmitter') return 'attached_to_transmitter';
            if (dest === 'transmitter_group') return 'attached_to_transmitter_group';
            if (source === 'user' && dest === 'user') return 'transfer_to_depot';
            if (['subscription', 'transmitter', 'transmitter_group'].includes(source) && dest === 'user') {
                if (desc.includes('arıza') || desc.includes('ariza') || desc.includes('defective')) {
                    return 'defective_return';
                }
                return 'return_to_depot';
            }
            if (dest === 'user' && !source) {
                if (desc.includes('arttır') || desc.includes('eklendi') || desc.includes('added')) {
                    return 'added';
                }
                return 'created';
            }
            if (desc.includes('satış') || desc.includes('satis') || desc.includes('sale')) {
                return 'sale';
            }

            return 'unknown';
        },
        movementLabel(rowOrType) {
            const type = rowOrType && typeof rowOrType === 'object'
                ? this.resolveMovementType(rowOrType)
                : rowOrType;
            if (!type) return '';
            const found = this.movementTypes.find(item => item.value === type);
            return found ? found.label : type;
        },
        loadItems() {

            this.$http.post('/stock', { search: this.searchItems, onlySearch: true })
                .then( (response) => {
                    this.rows = response.data
                })


        },
        resetFilters(){
            const today = new Date();
            const prior = new Date();
            prior.setMonth(prior.getMonth() - 1);
            this.filter.date_from = prior.toISOString().slice(0,10);
            this.filter.date_to = today.toISOString().slice(0,10);
            this.filter.user_id = null;
            this.filter.movement_type = null;
            this.filter.device_query = '';
            this.params.page = 1;
            this.loadPage();
        }
        ,
        async loadDepots(){
            const resp = await this.$http.post('/stock/depo')
            .catch(()=>({data:[]}));
            const data = resp.data || [];
            // remove duplicates by user_id to avoid Vue duplicate key warnings
            this.depots = data.filter((v, i, a) => a.findIndex(t => t.user_id === v.user_id) === i);
        },
        reLoadPage(query) {
            this.params.page = 1;
            this.searchQuery = query;
            if (this.deviceSearchTimer) clearTimeout(this.deviceSearchTimer);
            this.deviceSearchTimer = setTimeout(() => {
                this.loadPage(true);
                this.deviceSearchTimer = null;
            }, 400);
        },
        async loadPage(force = false){
            if ((this.isLoading || this.pageLoading) && !force) return false

            const requestId = ++this.loadRequestId;
            const search = (this.filter.device_query || this.searchQuery || '').trim();

            this.params.page === 1 ? this.isLoading = true : this.pageLoading = true

            const payload = {
                params: { ...this.params },
                columnFilters: {
                    user_id: this.filter.user_id,
                    search,
                    device_query: this.filter.device_query,
                    date_from: search ? null : this.filter.date_from,
                    date_to: search ? null : this.filter.date_to,
                    movement_type: this.filter.movement_type
                },
                search_query: search
            }

            try{
                const resp = await this.$http.post(this.endpoint, payload)
                if (requestId !== this.loadRequestId) return
                if(!resp || !resp.data) return

                if (this.params.page === 1) {
                    this.tableData.data = resp.data.data || []
                } else {
                    this.tableData.data = [...this.tableData.data, ...(resp.data.data || [])]
                }

                this.tableData.pagination = { current_page:resp.data.current_page, last_page:resp.data.last_page, total:resp.data.total }
            }finally{
                if (requestId === this.loadRequestId) {
                    this.params.page === 1 ? this.isLoading = false : this.pageLoading = false
                }
            }
        },
        handleDeviceInput() {
            if (this.deviceSearchTimer) clearTimeout(this.deviceSearchTimer);
            this.deviceSearchTimer = setTimeout(() => {
                this.params.page = 1;
                this.loadPage(true);
                this.deviceSearchTimer = null;
            }, 400);
        },
        openDetailModal(row) {
            this.selectedRow = row;
            this.detailModalVisible = true;
        },
        closeDetailModal() {
            this.selectedRow = null;
            this.detailModalVisible = false;
        },
    },
    async mounted(){
        await this.loadDepots();
        this.resetFilters();
    },
    beforeDestroy(){
        if (this.deviceSearchTimer) clearTimeout(this.deviceSearchTimer);
    },

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">

                <!-- Filters moved into Datatable searchItems slot -->

                <Datatable
                    :columns="columns"
                    :tableData="tableData"
                    @sort-column="handleSortColumn"
                    @row-click="openDetailModal"
                    @search-query="reLoadPage"
                    :loading="isLoading"
                    :poading="pageLoading">

                    <template #searchItems>
                        <div class="col-lg-12 mt-2">
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="mb-3">
                                        <label>Cihaz / Barkod Ara</label>
                                        <div class="input-group">
                                            <input type="text" class="form-control" v-model="filter.device_query" @input="handleDeviceInput" placeholder="Barkod veya ürün adı ara" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="mb-3">
                                        <label>Depo</label>
                                        <select class="form-select" v-model="filter.user_id" @change.prevent="params.page=1; loadPage()">
                                            <option :value="null">Tüm Depolar</option>
                                            <option v-for="(d, idx) in depots" :key="d.user_id + '-' + idx" :value="d.user_id">{{ d.user_name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-3">
                                        <label>Hareket Tipi</label>
                                        <select class="form-select" v-model="filter.movement_type" @change.prevent="params.page=1; loadPage()">
                                            <option :value="null">Tümü</option>
                                            <option
                                                v-for="type in movementTypes"
                                                :key="type.value"
                                                :value="type.value"
                                            >{{ type.label }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-3">
                                        <label>Başlangıç</label>
                                        <input type="date" class="form-control" v-model="filter.date_from" @change.prevent="params.page=1; loadPage()" />
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-3">
                                        <label>Bitiş</label>
                                        <input type="date" class="form-control" v-model="filter.date_to" @change.prevent="params.page=1; loadPage()" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>

                    <template #created_at="{ row }">{{ formatDate(row.created_at, 'DD.MM.YYYY HH:mm') }}</template>
                    <template #amount="{ row }">{{ formatAmountWithUnit(row.amount, row.unit) }}</template>
                    <template #movement_type="{ row }">{{ movementLabel(row) }}</template>

                    <template #movement="{ row }">
                        <div class="d-flex align-items-center">
                            <small class="text-muted me-2">Hareket:</small>
                            <div>
                                <!-- Use normalized movement when available -->
                                <template v-if="row.movement_type && (row.source_name || row.destination_name)">
                                    <span class="badge bg-secondary text-white">{{ movementLabel(row) }}</span>
                                    <span class="mx-2">→</span>
                                    <span class="badge bg-light text-dark">{{ row.source_name || '—' }}</span>
                                    <span class="mx-2">→</span>
                                    <span class="badge bg-info text-dark">{{ row.destination_name || '—' }}</span>
                                </template>

                                <!-- Fallback to legacy stock_detail fields if normalized not present -->
                                <template v-else>
                                    <template v-if="!row.user_id && (row.to_user_id || row.subscription_id || row.transmitter_id || row.transmitter_group_id)">
                                        <span class="badge bg-secondary text-white">
                                          <template v-if="row.subscription_id">Müşteri</template>
                                          <template v-else-if="row.transmitter_id">Verici</template>
                                          <template v-else-if="row.transmitter_group_id">POP</template>
                                          <template v-else>Kaynak</template>
                                        </span>
                                        <span class="mx-2">→</span>
                                        <span class="badge bg-light text-dark">{{ row.to_depo_name || row.depo_name || '—' }}</span>
                                    </template>

                                    <template v-else-if="row.to_user_id">
                                        <span class="badge bg-light text-dark">{{ row.depo_name || '—' }}</span>
                                        <span class="mx-2">→</span>
                                        <span class="badge bg-light text-dark">{{ row.to_depo_name || '—' }}</span>
                                    </template>

                                    <template v-else-if="row.transmitter_id">
                                        <span class="badge bg-light text-dark">{{ row.depo_name || '—' }}</span>
                                        <span class="mx-2">→</span>
                                        <span class="badge bg-info text-white">{{ row.transmitter_name || '—' }}</span>
                                    </template>

                                    <template v-else-if="row.transmitter_group_id">
                                        <span class="badge bg-light text-dark">{{ row.depo_name || '—' }}</span>
                                        <span class="mx-2">→</span>
                                        <span class="badge bg-warning text-dark">{{ row.transmitter_group_name || '—' }}</span>
                                    </template>

                                    <template v-else>
                                        <span class="badge bg-danger text-white">Çıkış</span>
                                        <span class="ms-2">{{ row.depo_name || '—' }}</span>
                                    </template>
                                </template>
                            </div>
                        </div>
                    </template>
                </Datatable>
                <!-- Detail Modal -->
                <div v-if="detailModalVisible" class="modal fade show" style="display:block; background: rgba(0,0,0,0.5);">
                    <div class="modal-dialog modal-lg modal-dialog-centered">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Hareket Detayı</h5>
                                <button type="button" class="btn-close" @click="closeDetailModal"></button>
                            </div>
                            <div class="modal-body">
                                <div v-if="selectedRow">
                                    <p><strong>Hareket Tipi:</strong> {{ movementLabel(selectedRow) }}</p>
                                    <p><strong>Ürün:</strong> {{ selectedRow.stock_name }}</p>
                                    <p><strong>Grup:</strong> {{ selectedRow.stock_group_name }}</p>
                                    <p><strong>Oluşturan:</strong> {{ selectedRow.created_by_name || '—' }}</p>
                                    <p><strong>Miktar:</strong> {{ formatAmountWithUnit(selectedRow.amount, selectedRow.unit) }}</p>
                                    <p><strong>Nereden:</strong> {{ selectedRow.source_name || '—' }}</p>
                                    <p><strong>Nereye:</strong> {{ selectedRow.destination_name || '—' }}</p>
                                    <p><strong>Açıklama:</strong> {{ selectedRow.description || '—' }}</p>
                                    <p><strong>Tarih:</strong> {{ formatDate(selectedRow.created_at, 'DD.MM.YYYY HH:mm') }}</p>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-secondary" @click="closeDetailModal">Kapat</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>



  </Layout>
</template>
